import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import InputModal from '../modal/DimensionsModal/InputModal'
import ToolBar from './ToolBar'
import { useKonva } from '../context/KonvaContext'
import KonvaStage from './KonvaStage'
import TotalAreaCalculationModal from '../modal/TotalAreaCalculationsModal/TotalAreaCalculationModal'
import { IoMdHelp } from 'react-icons/io'
import Instructions from './Instructions'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'
import { convertedWidth } from '../utils/calculationUtils'
Modal.setAppElement('#root')

const Konva = () => {
    const {
        shapes,
        setModalIsOpen,
        selectedShapeId,
        setSideDimensions,
        sideDimensions,
        setShapeAreas,
        setShapeData,
        setSuggestDimension,
        selectedDimension,
        setShapesHistory,
        setSelectedDimension,
        shapesHistory,
        shapeData,
        selectedSuggestionIndex,
        setIsHelpModalOpen,
        setSelectedDimensionHistory,
        selectedDimesionHistory,
        shapeAreas
    } = useKonva()

    const [errorObj, setErrorObj] = useState({})
    const [isCalculationModalOpen, setIsCalculationModalOpen] = useState(false)

    const persistData = (possibilities) => {
        setSelectedDimensionHistory(null)
        setSuggestDimension(possibilities)
        setShapeData((prevData) => ({
            ...prevData,
            [selectedShapeId]: {
                dimensions: sideDimensions,
                possibleDimensions: possibilities
            }
        }))
        setShapesHistory((prevHistory) => {
            const updatedHistory = { ...prevHistory }

            if (updatedHistory[selectedShapeId]) {
                updatedHistory[selectedShapeId]["dimensions"] = sideDimensions
                updatedHistory[selectedShapeId]["possibleDimensions"] = possibilities
            }
            return updatedHistory
        })
    }
    function calculatePossibleDimensions(length, width, selectedShape) {
        const { [selectedShapeId]: removeError, ...updatedErrorObj } = errorObj
        setErrorObj(updatedErrorObj)
        const possibilities = []
        const width1 = convertedWidth(length)
        const height1 = width
        const area1 = width1 * height1
        possibilities.push({
            id: uuidv4(),
            width: width1,
            height: height1,
            area: area1,
            originalWidth: length,
        })
        if (selectedShape?.type === 'circle') {
            persistData(possibilities)
            return possibilities[0]
        }
        const height2 = length
        const width2 = convertedWidth(width)
        const area2 = width2 * height2
        possibilities.push({
            id: uuidv4(),
            width: width2,
            height: height2,
            area: area2,
            originalWidth: width,
        })
        // Find the combination with the minimum area
        const minAreaCombination = possibilities.reduce((min, current) => {
            return current.area < min.area ? current : min
        })
        persistData(possibilities)
        return minAreaCombination
    }

    const handleCalculateClick = () => {
        if (!Object.keys(sideDimensions).length) {
            setErrorObj({
                ...errorObj,
                [selectedShapeId]: 'Please enter dimensions.'
            })
            return
        }

        if(shapeAreas[selectedShapeId]) {
            const { [selectedShapeId]: removeShapeId, ...updatedShapeArea } = shapeAreas
            setShapeAreas(updatedShapeArea)
            setSelectedDimension(null)
        }   
        if(shapesHistory[selectedShapeId])  {
            delete shapesHistory[selectedShapeId].shapeArea
        }    
        const { width, height, radius, base } = sideDimensions
        const selectedShape = shapes.find(({ id }) => id === selectedShapeId)

        const widthValid = width !== undefined && !isNaN(width) && width > 0
        const heightValid = height !== undefined && !isNaN(height) && height > 0
        const baseValid = base !== undefined && !isNaN(base) && base > 0
        const radiusValid = radius !== undefined && !isNaN(radius) && radius > 0

        if ((selectedShape.type === 'rectangle' || selectedShape.type === 'LShape') && widthValid && heightValid) {
            if (selectedShape.type === 'LShape') {
                calculatePossibleDimensions(width, height, selectedShape)
            } else if (width !== height) {
                calculatePossibleDimensions(width, height, selectedShape)
            } else {
                setErrorObj({
                    ...errorObj,
                    [selectedShapeId]: 'Width and height can not be equal for selected shape.'
                })
            }
        } else if (selectedShape.type === 'square' && widthValid && heightValid) {
            calculatePossibleDimensions(width, height, selectedShape)
        } else if (selectedShape.type === 'circle' && radiusValid) {
            calculatePossibleDimensions(radius * 2, radius * 2, selectedShape)
        } else if (selectedShape.type === 'triangle' && baseValid && heightValid) {
            calculatePossibleDimensions(base, height, selectedShape)
        } else {
            setErrorObj({
                ...errorObj,
                [selectedShapeId]: 'Please enter valid dimensions.'
            })
        }
    }

    const handleModalSubmit = () => {
        const prevArea = shapesHistory[selectedShapeId]?.shapeArea
        if ((!errorObj[selectedShapeId] && selectedDimension) || prevArea) {
            const area = selectedDimension?.area || prevArea
            setShapeAreas((prevAreas) => ({
                ...prevAreas,
                [selectedShapeId]: area,
            }))

            const updatedDimesions = shapeData[selectedShapeId]?.possibleDimensions?.map((pd, i) => {
                if (i === selectedSuggestionIndex) {
                    return { ...pd, checked: true }
                } else {
                    return { ...pd, checked: false }
                }
            })
            const updatedShapeData = {
                ...shapeData,
                [selectedShapeId]: {
                    ...shapeData[selectedShapeId],
                    possibleDimensions: updatedDimesions,
                    currentSelectedDimension: selectedDimesionHistory
                }
            }
            setShapeData(updatedShapeData)

            setShapesHistory((prevHistory) => {
                const updatedHistory = { ...prevHistory }

                if (updatedHistory[selectedShapeId]) {
                    updatedHistory[selectedShapeId]["shapeArea"] = area
                    updatedHistory[selectedShapeId]["possibleDimensions"] = updatedDimesions
                    updatedHistory[selectedShapeId]["currentSelectedDimension"] = selectedDimesionHistory
                }

                return updatedHistory
            })

            handleCalculationModal()

            setSideDimensions({})
            setModalIsOpen(false)
            setSuggestDimension([])
            setSelectedDimension(null)
            setSelectedDimensionHistory(null)
        } else {
            if (!Object.keys(shapeData).length) {
                setErrorObj({
                    ...errorObj,
                    [selectedShapeId]: 'Please calculate the dimensions first.'
                })
            } else
                setErrorObj({
                    ...errorObj,
                    [selectedShapeId]: 'Please select any dimension.'
                })
        }
    }

    const handleCalculationModal = () => {
            setIsCalculationModalOpen(true)
    }

    useEffect(() => {
        if (selectedDimension) {
            const { [selectedShapeId]: removeError, ...updatedErrorObj } = errorObj
            setErrorObj(updatedErrorObj)
        }
    }, [selectedDimension])  //eslint-disable-line

    return (
        <div className="turf_calculation_wrapper">
            <ToolBar />
            <KonvaStage />
            <InputModal
                handleModalSubmit={handleModalSubmit}
                validationError={errorObj[selectedShapeId] || ''}
                calculatePossibleDimensions={calculatePossibleDimensions}
                handleCalculateClick={handleCalculateClick}
            />
            <TotalAreaCalculationModal
                open={isCalculationModalOpen}
                onClose={() => setIsCalculationModalOpen(false)}
            />
            <OverlayTrigger
                placement={'top'}
                overlay={
                    <Tooltip id={'help'}>
                        {'Help'}
                    </Tooltip>
                }
            >
                <button className='help_btn' type={'help'} onClick={() => setIsHelpModalOpen(true)}>
                    <IoMdHelp />
                </button>
            </OverlayTrigger>
            <Instructions />
        </div>
    )
}

export default Konva
